import http from "@/axios/http-common";

const versionKey = process.env.VUE_APP_VERSION_KEY,
  isProd = process.env.NODE_ENV === "production" ? true : false;

export default class RefreshPageClass {
  currentHash = versionKey;
  versionUpdated = false;
  newHash = "";
  errorStatus = null;
  isProd = isProd;
  checkUpdateInterval = 1000 * 60 * 30;

  initVersionCheck(frequency = this.checkUpdateInterval) {
    console.log(`init version check...`)

    if (this.isProd) {
      console.log(`try to check prod version... Intervaled every: ${this.checkUpdateInterval / 60000} minutes. Current ver: ${this.currentHash}`);
      this.checkVersion();

      setInterval(() => {
        this.checkVersion();
      }, frequency);
    } else {
      console.log('unfortunately this is not prod env so checking not executed')
    }
  }

  async checkVersion() {
    try {
      console.log("checking version....");
      const resp = await http.getData(`/app-ui-version-hash?uiver=${this.currentHash}`);

      console.log("check hash changed on checking", this.versionUpdated);

      console.log(resp.data);

      this.newHash = resp.data.hash;

      this.versionUpdated = this.hasVersionUpdate(this.currentHash, this.newHash);
      console.log("check hash changed after checking", this.versionUpdated);
      console.log("currentHash", this.currentHash, "newHash", this.newHash);

      if (this.isProd) {
        if (this.versionUpdated) {
          location.reload();
        }
      } else {
        console.log("this is not production so hash reload not executed");
      }
    } catch (error) {
      // this.loading = false;
      if (!error.response) {
        this.errorStatus = "Error: Network Error";
      } else {
        this.errorStatus = error.response.data.message;
      }
    }
  }

  hasVersionUpdate(currentHash, newHash) {
    if (currentHash && newHash > currentHash) {
      return true;
    } else {
      return false;
    }
  }
}
